import CollaborationService from './CollaborationService';

class HackerRankService implements CollaborationService {
  readonly name = 'HackerRank';

  readonly logoUrl = '/static/images/integrations/hackerrank.png';
}

export default new HackerRankService();
